const prozorroEdsModule = require("@prozorro/prozorro-eds");
const ProzorroEds = prozorroEdsModule.ProzorroEds || prozorroEdsModule.default || prozorroEdsModule;

if (!ProzorroEds || typeof ProzorroEds.init !== 'function') {
    throw new Error('Cannot initialize @prozorro/prozorro-eds: ProzorroEds export is missing');
}

window.ProzorroEds = ProzorroEds;
